import Head from 'next/head';
import React from 'react';

type Props = {};

const FeedbackIframe = (props: Props) => {
  return (
    <>
      <Head>
        <title>Ticket Feedback - Iframe</title>
      </Head>

      <div className="h-screen flex items-center justify-center relative overflow-hidden">
        <iframe
          src="https://dev.ticket-feedback.phpr.link/feedback"
          allowFullScreen
          className="w-full h-full"
        ></iframe>
      </div>
    </>
  );
};

export default FeedbackIframe;
